import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreEndpointsConstant } from '@constants/store-endpoints.constant';
import { PersonSearchOptions } from '@models/custom-fields.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonService {
  constructor(private http: HttpClient) {}

  search(term: string, limit: number = 10): Observable<PersonSearchOptions> {
    return this.http.get<PersonSearchOptions>(StoreEndpointsConstant.PERSON_SEARCH, {
      params: {
        searchQuery: term
      }
    });
  }
}
